import BaseCard from "../BaseCard";
import { ArticleCard, BundleCard, VideoCard } from "./builders";

import {
  ContentTypeEnum,
  CardViewmodelAndProps,
} from "./ContentCardV2.interface";

const ContentCardV2 = (props: CardViewmodelAndProps) => {
  const contentType = props?.metadata?.content_type;

  if (contentType === ContentTypeEnum.ARTICLE) {
    return <ArticleCard dataQaSelector="article-content-card" {...props} />;
  }

  if (contentType === ContentTypeEnum.BUNDLE) {
    return <BundleCard dataQaSelector="bundle-content-card" {...props} />;
  }

  if (contentType === ContentTypeEnum.INTERACTIVE_VIDEO) {
    return (
      <VideoCard dataQaSelector="interactive-video-content-card" {...props} />
    );
  }

  if (contentType === ContentTypeEnum.GENERATION_GENIUS_VIDEO) {
    return (
      <VideoCard dataQaSelector="generation-genius-content-card" {...props} />
    );
  }

  if (contentType === ContentTypeEnum.WORKSHEET) {
    return (
      <BaseCard
        contentId={props?.id}
        contentTag="Resource"
        displayDate={props.display_date}
        images={props.images}
        url={props.url}
        title={props.title}
      />
    );
  }

  return null;
};

export default ContentCardV2;
